import * as React from 'react';
import { RadioGroup } from "@progress/kendo-react-inputs";
const data = [
  {
    label: "Exportacion",
    value: "E",
  },
  {
    label: "Nacional",
    value: "N",
  }
];
const Mercados = () => {
  return <div > <RadioGroup layout='horizontal'   data={data} />
         </div>; 
};
export default Mercados;